/** General/code chat offers the existing default or an explicit xhigh override. */
export type ChatEffort = "default" | "xhigh";

// Conservative capability list: unknown models keep their existing settings.
// Sources: OpenAI model docs and Anthropic's effort compatibility table.
export function supportsExtraHighChatEffort(modelId: string): boolean {
  const id = modelId.trim().toLowerCase().replace(/^(openai|anthropic|claude)\//, "");
  if (/-chat(?:-|$)/.test(id)) return false;
  return (
    /^gpt-(?:5\.(?:2|4|5|6)|6(?:\.1)?)(?:-|$)/.test(id) ||
    /^gpt-5\.3-codex(?:-|$)/.test(id) ||
    /^claude-(?:sonnet-5|opus-(?:5|4-[78])|haiku-5-5|fable-5|mythos-5)(?:-|$)/.test(id)
  );
}

export function resolveChatEffort(modelId: string, requested: unknown): ChatEffort {
  return requested === "xhigh" && supportsExtraHighChatEffort(modelId)
    ? "xhigh"
    : "default";
}
